export class ProcedureInstanceVisibilityBase {

    id!: number;
    subject!: string
    ref!:string
    shared!:boolean;

    static from(source: ProcedureInstanceVisibility): ProcedureInstanceVisibilityBase {

        let current = new ProcedureInstanceVisibilityBase();
        Object.assign(current, source)
        return current;
    }

    copy(org:ProcedureInstanceVisibility){
        this.id = org.id
        this.subject = org.subject
        this.ref = org.ref
        this.shared = org.shared
    }

    getSubject(): string {

        if (this.subject == null || this.subject.trim() == "") {
            return "Sense assumpte"
        }
        return this.subject
    }

}

export interface ProcedureInstanceVisibility extends ProcedureInstanceVisibilityBase {

}